import { render, staticRenderFns } from "./NewClothingPopup.vue?vue&type=template&id=f1bb8e08&"
import script from "./NewClothingPopup.vue?vue&type=script&lang=js&"
export * from "./NewClothingPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports